<!--
	Кольцо готовности загрузки.

	Круг, а не полоса: он не зависит от ширины снимка и одинаково читается на
	маленькой плитке альбома и на фотографии во весь пузырь.
-->
<script lang="ts">
	interface Props {
		/** Доля готовности, 0…1. */
		ratio: number;
		size?: number;
	}

	let { ratio, size = 44 }: Props = $props();

	const RADIUS = 18;
	const LENGTH = 2 * Math.PI * RADIUS;

	let done = $derived(Math.max(0, Math.min(1, ratio)));
</script>

<svg
	class="ring"
	width={size}
	height={size}
	viewBox="0 0 44 44"
	role="progressbar"
	aria-label="Загрузка"
	aria-valuenow={Math.round(done * 100)}
	aria-valuemin="0"
	aria-valuemax="100"
>
	<circle class="track" cx="22" cy="22" r={RADIUS} />
	<!-- Начинаем сверху и идём по часовой: иначе кольцо растёт «с трёх часов». -->
	<circle
		class="done"
		cx="22"
		cy="22"
		r={RADIUS}
		stroke-dasharray="{LENGTH} {LENGTH}"
		stroke-dashoffset={LENGTH * (1 - done)}
		transform="rotate(-90 22 22)"
	/>
</svg>

<style>
	.ring {
		display: block;
	}

	.track,
	.done {
		fill: none;
		stroke-width: 3;
		stroke-linecap: round;
	}

	.track {
		stroke: rgba(255, 255, 255, 0.3);
	}

	.done {
		stroke: #fff;
		transition: stroke-dashoffset var(--duration-fast) linear;
	}
</style>
